var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { CancelledPromiseError, promiseWithTimeout, } from "./utils/promiseUtils";
export var PortalMessageType;
(function (PortalMessageType) {
    PortalMessageType["USER_INFO"] = "USER_INFO";
    PortalMessageType["IS_RUNNING_ON_PORTAL"] = "IS_RUNNING_ON_PORTAL";
    PortalMessageType["ACCESS_TOKEN"] = "ACCESS_TOKEN";
    PortalMessageType["NEW_TOKEN"] = "NEW_TOKEN";
    PortalMessageType["NOT_AUTHENTICATED"] = "NOT_AUTHENTICATED";
    PortalMessageType["INITIALIZED"] = "INITIALIZED";
    PortalMessageType["LOGIN"] = "LOGIN";
    PortalMessageType["LOGOUT"] = "LOGOUT";
    PortalMessageType["REGISTER"] = "REGISTER";
    PortalMessageType["ACCOUNT_MANAGEMENT"] = "ACCOUNT_MANAGEMENT";
    PortalMessageType["REDIRECT_TO"] = "REDIRECT_TO";
    PortalMessageType["DOWNLOAD"] = "DOWNLOAD";
    PortalMessageType["GET_CURRENT_POSITION"] = "GET_CURRENT_POSITION";
    PortalMessageType["MESSAGE_TO_APP"] = "MESSAGE_TO_APP";
})(PortalMessageType || (PortalMessageType = {}));
export var InternalMessageEventType;
(function (InternalMessageEventType) {
    InternalMessageEventType["NEW_ACCESS_TOKEN"] = "NEW_ACCESS_TOKEN";
    InternalMessageEventType["INITIALIZED"] = "INITIALIZED";
    InternalMessageEventType["LOCATION_CHANGED"] = "LOCATION_CHANGED";
    InternalMessageEventType["MESSAGE_TO_APP"] = "MESSAGE_TO_APP";
})(InternalMessageEventType || (InternalMessageEventType = {}));
export class WebgateConnect {
    constructor(config) {
        this.config = config;
        //@ts-ignore
        this.target = (window === null || window === void 0 ? void 0 : window.ReactNativeWebView) || (window === null || window === void 0 ? void 0 : window.parent) || window;
        this.listeners = {};
        this.listenPortalMessagesToApp();
        this.listenToPortalMessages();
    }
    isRunningInPortal() {
        var _a;
        return this.config.portalUrl.indexOf((_a = this.target) === null || _a === void 0 ? void 0 : _a.location.hostname) !== -1;
    }
    isRunningInWebview() {
        //@ts-ignore
        return typeof window !== "undefined" ? !!(window === null || window === void 0 ? void 0 : window.ReactNativeWebView) : false;
    }
    login(options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.LOGIN, options).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    logout(options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.LOGOUT, options).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    accountManagement() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.ACCOUNT_MANAGEMENT, null).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    getUserInfo() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.USER_INFO, null).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    register(options) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.REGISTER, options).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    getAccessToken() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.ACCESS_TOKEN, null);
        });
    }
    redirectTo(uri) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.REDIRECT_TO, uri).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    download(payload) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.DOWNLOAD, payload).catch((err) => {
                if (err instanceof CancelledPromiseError) {
                    return;
                }
            });
        });
    }
    getCurrentPosition() {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.sendMessageToPortal(PortalMessageType.GET_CURRENT_POSITION, null, 30000 // 30 seconds
            );
        });
    }
    listenToPortalMessages() {
        return __awaiter(this, void 0, void 0, function* () {
            window === null || window === void 0 ? void 0 : window.addEventListener("message", (event) => {
                var _a;
                // TODO: remove this line
                if (event.origin.indexOf(this.config.portalUrl) !== -1) {
                    switch (event.data.type) {
                        case PortalMessageType.NEW_TOKEN:
                            this.emit(InternalMessageEventType.NEW_ACCESS_TOKEN, event.data.payload);
                            break;
                        case PortalMessageType.NOT_AUTHENTICATED:
                            this.emit(InternalMessageEventType.NEW_ACCESS_TOKEN, undefined);
                            break;
                        case PortalMessageType.INITIALIZED:
                            this.emit(InternalMessageEventType.INITIALIZED, (_a = event === null || event === void 0 ? void 0 : event.data) === null || _a === void 0 ? void 0 : _a.payload);
                            break;
                    }
                }
            }, true);
        });
    }
    sendMessageToPortal(type, payload, timeout) {
        const target = this.target;
        return promiseWithTimeout(new Promise((resolve, reject) => {
            if (this.isRunningInWebview()) {
                target.postMessage(JSON.stringify({
                    type,
                    payload,
                }));
            }
            else {
                target.postMessage(JSON.stringify({
                    type,
                    payload,
                }), "*");
            }
            const messageHandler = (event) => {
                if (event.origin.indexOf(this.config.portalUrl) !== -1 &&
                    event.data.type === `${type}_RESPONSE`) {
                    window.removeEventListener("message", messageHandler);
                    resolve(event.data.payload);
                }
            };
            window === null || window === void 0 ? void 0 : window.addEventListener("message", messageHandler);
        }).catch((e) => {
            return e;
        }), timeout);
    }
    listenPortalMessagesToApp() {
        window === null || window === void 0 ? void 0 : window.addEventListener("messageToApp", (event) => {
            this.emit(InternalMessageEventType.MESSAGE_TO_APP, event);
        });
    }
    on(eventType, listener) {
        if (!this.listeners[eventType]) {
            this.listeners[eventType] = [];
        }
        this.listeners[eventType].push(listener);
    }
    emit(eventType, data) {
        if (!this.listeners[eventType]) {
            return;
        }
        this.listeners[eventType].forEach((listener) => listener(data));
    }
}
